module.exports = __webpack_public_path__ + "static/media/dokulogo.573aa71d.png";